import { useEffect } from 'react';
import { listenHourRange } from '../../channels/hourRangeChannel';
import { useHourFilterStore } from '../../stores/useHourFilterStore';

export function useHourRangeChannel() {

    useEffect(() => {

        const unsubscribe = listenHourRange(({ tipo, payload }) => {

            if (tipo !== 'hour-range-upsert') {
                return;
            }

            const {
                setHourRange,
                setOperationalContextInitialized
            } = useHourFilterStore.getState();

            setHourRange(
                payload.hourRange,
                false,
                payload.manual
            );

            if (payload.initialSync) {
                setOperationalContextInitialized(true);
            }

        });

        return unsubscribe;

    }, []);

}